import React from "react";

import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import UploadFileIcon from "@mui/icons-material/UploadFile";

import { ButtonUI } from "../../Common";

const UploadSection = ({ file, uploadFile }) => {
  return (
    <Grid container spacing={3}>
      <Grid
        size={{
          xs: 12,
          sm: 6
        }}>
        <TextField
          required
          label="File"
          fullWidth
          style={{ flex: 1 }}
          variant="outlined"
          value={file}
          helperText={"Supported File Type: Delimited files"}
        />
      </Grid>
      <Grid
        sx={{ display: "flex", alignItems: "flex-start", mt: "12px" }}
        size={{
          xs: 12,
          sm: 6
        }}>
        <label htmlFor={"contained-button-file"} style={{ marginRight: "30px", whiteSpace: "nowrap" }}>
          <input style={{ display: "none" }} type="file" id={"contained-button-file"} onChange={uploadFile} />
          <ButtonUI color="secondary" variant="contained" component="span" endIcon={<UploadFileIcon />}>
            Browse
          </ButtonUI>
        </label>
      </Grid>
    </Grid>
  );
};

export default React.memo(UploadSection);
